import { Navigate, Route, Routes } from 'react-router-dom';
import Categories from '../Categories/Categories';
import CategoryCreatePage from '../Categories/Category';
import ResourceListPage from '../ResourceList';
import ResourceCreatePage from '../ResourceList/ResourceCreate';
import ResourcePdfViewer from '../ResourceList/ResourcePdfViewer';
import ResourceCardsView from '../ResourceList/ResourceCardsView';
import React from 'react';
import CategoryOverview from '../AlignHome/CategoryOverview';
import ResourceInlineView from '../ResourceList/ResourceInlineView';
import ResourceAttachmentView from '../ResourceList/ResourceAttachmentView';
import CategoryDisplay from '../Categories/CategoryDisplay';
import CoursePage from '../Course';

export const AlignRoutes = () => {
	return (
		<Routes>
			<Route
				path="categories"
				element={
					<ProtectedRoute>
						<Categories />
					</ProtectedRoute>
				}
			/>

			<Route
				path="resources"
				element={
					<ProtectedRoute>
						<ResourceCardsView local={true} />
					</ProtectedRoute>
				}
			/>

			<Route
				path="resources/category/:categoryId"
				element={
					<ProtectedRoute>
						<CategoryDisplay />
					</ProtectedRoute>
				}
			/>

			<Route
				path="resources/category/:categoryId/:type"
				element={
					<ProtectedRoute>
						<CategoryDisplay />
					</ProtectedRoute>
				}
			/>

			<Route
				path="resources/category/:categoryId/:type/view/:resourceId"
				element={
					<ProtectedRoute>
						<ResourceInlineView />
					</ProtectedRoute>
				}
			/>

			<Route
				path="resources/category/:categoryId/:type/preview/:resourceId"
				element={
					<ProtectedRoute>
						<ResourceAttachmentView />
					</ProtectedRoute>
				}
			/>

			<Route
				path="resources/edit/:resourceId/pdf/:pdfId"
				element={
					<ProtectedRoute>
						<ResourcePdfViewer />
					</ProtectedRoute>
				}
			/>

			<Route path="/" element={<CoursePage />} />
		</Routes>
	);
};

const ProtectedRoute = ({ children }) => {
	if (!window.sessionStorage.getItem('accessToken')) {
		return <Navigate to="blank" />;
	}
	return children;
};
